import React, { useState, useEffect, useRef } from "react";
import "./AIWrapper.css";
import AIcomp from "../assets/images/AIcomp.jpg";
import Graph from "../assets/images/graph.jpeg";
// import PopupImage from "../assets/images/aiwrapper-img.jpeg"; // ✅ Popup Image
import LeftLogo from "../assets/images/techdestination-logo.png";
import TagLine from "../assets/images/TagLine.png";
import RightLogo from "../assets/images/ignite-logo.png";
import { FaArrowUp } from "react-icons/fa";



// ✅ Domain logos
import ETech from "../assets/images/ETech.png";
import HTech from "../assets/images/HTech.png";
import GTech from "../assets/images/GTech.png";
import CTech from "../assets/images/CTech.png";
import FTech from "../assets/images/FTech.png";
// Partners logos

import Partner2 from "../assets/images/partner2.png";
import Partner3 from "../assets/images/partner3.png";
import Partner4 from "../assets/images/partner4.png";
import Partner5 from "../assets/images/partner5.png";
import Partner6 from "../assets/images/partner6.png";
import Partner7 from "../assets/images/partner7.png";
import Partner8 from "../assets/images/partner8.png";
import Partner9 from "../assets/images/partner9.png";
import Partner10 from "../assets/images/partner10.png";
import Partner11 from "../assets/images/partner11.png";
import Partner12 from "../assets/images/partner12.png";


// Gallery images
// import gallery1 from "../assets/images/gallery1.jpeg"; // path adjust if needed
// import gallery2 from "../assets/images/gallery2.jpeg"; // path adjust if needed
import Isb1 from "../assets/images/Isb1.jpg"; // path adjust if needed
import Isb2 from "../assets/images/Isb2.jpg";
import Isb3 from "../assets/images/Isb3.jpg";

import Que1 from "../assets/images/Que1.jpg";
import Que2 from "../assets/images/Que2.jpg";
import Que3 from "../assets/images/Que3.jpg";

import Pew1 from "../assets/images/Pew1.jpg";
import Pew2 from "../assets/images/Pew2.jpg";
import Pew3 from "../assets/images/Pew3.jpg";

import Khi1 from "../assets/images/Khi1.jpg";
import Khi2 from "../assets/images/Khi2.jpg";
import Khi3 from "../assets/images/Khi3.jpg";

import Lhr1 from "../assets/images/Lhr1.jpg";
import Lhr2 from "../assets/images/Lhr2.jpg";
import Lhr3 from "../assets/images/Lhr3.jpg";

import win1 from "../assets/images/win1.jpg";
import win2 from "../assets/images/win2.jpg";
import win3 from "../assets/images/win3.jpg";
import win4 from "../assets/images/win4.jpg";
import win5 from "../assets/images/win5.jpg";
import win from "../assets/images/win.jpg";

import Rup11 from "../assets/images/Rup11.jpg";
import Rup12 from "../assets/images/Rup12.jpg";
import Rup13 from "../assets/images/Rup13.jpg";
import Rup14 from "../assets/images/Rup14.jpg";
import Rup15 from "../assets/images/Rup15.jpg";

import Rup21 from "../assets/images/Rup21.jpg";
import Rup22 from "../assets/images/Rup22.jpg";
import Rup23 from "../assets/images/Rup23.jpg";
import Rup24 from "../assets/images/Rup24.jpg";







const AIWrapper = () => {
  // ✅ Countdown Timer Logic
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  const [isRegistrationActive, setIsRegistrationActive] = useState(false);

  useEffect(() => {
    const openDate = new Date("2025-09-25T00:00:00").getTime();
    const closeDate = new Date("2025-10-10T23:59:59").getTime();

    const interval = setInterval(() => {
      const now = new Date().getTime();

      if (now >= openDate && now <= closeDate) {
        // ✅ Registration Open
        setIsRegistrationActive(true);

        const diff = closeDate - now;
        setTimeLeft({
          days: Math.floor(diff / (1000 * 60 * 60 * 24)),
          hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((diff / (1000 * 60)) % 60),
          seconds: Math.floor((diff / 1000) % 60),
        });
      } else {
        // ✅ Registration Closed
        setIsRegistrationActive(false);
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      }
    }, 1000);

    return () => clearInterval(interval);
  }, []);


  // ✅ Scroll-to-top logic
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const toggleVisibility = () => {
      setIsVisible(window.scrollY > 300);
    };
    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // ✅ Active tab state
  const [activeTab, setActiveTab] = useState(null);

  // ✅ Refs for all sections
  const aboutRef = useRef(null);
  const timelineRef = useRef(null);
  const objectivesRef = useRef(null);
  const thematicareasRef = useRef(null);
  const evaluationRef = useRef(null);
  const partnersRef = useRef(null);
  const guidelinesRef = useRef(null);
  const resultsRef = useRef(null);
  const galleryRef = useRef(null);
  // const registerRef = useRef(null);

  // ✅ Handle tab click
  const handleTabClick = (tabName, sectionRef) => {
    setActiveTab(tabName);
    sectionRef.current.scrollIntoView({ behavior: "smooth" });
  };

  // ✅ Scroll listener to update active tab dynamically
  useEffect(() => {
    const sections = [
      { ref: aboutRef, name: "About" },
      { ref: timelineRef, name: "Timeline" },
      { ref: objectivesRef, name: "Objectives" },
      { ref: thematicareasRef, name: "Thematic Areas" },
      { ref: evaluationRef, name: "Evaluation" },
      { ref: partnersRef, name: "Partners" },
      { ref: guidelinesRef, name: "Guidelines" },
      { ref: resultsRef, name: "Results" },
      { ref: galleryRef, name: "Gallery" },
      // { ref: registerRef, name: "Register" },
    ];

    

    const onScroll = () => {
      const scrollPos = window.scrollY + 150;

      const firstSectionTop = aboutRef.current.offsetTop;

      // ✅ If user is above the first section, deactivate all tabs
      if (scrollPos < firstSectionTop) {
        setActiveTab(null);
        return;
      }

      // ✅ Otherwise, find the current section
      for (let i = sections.length - 1; i >= 0; i--) {
        const sectionTop = sections[i].ref.current.offsetTop;
        if (scrollPos >= sectionTop) {
          setActiveTab(sections[i].name);
          break;
        }
      }
    };

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);


  return (
    <>
      <title>AIWrapper Competition</title>

      <div className="ai-wrapper-container">
        {/* Logos */}
        <div className="ai-logos">
          <img src={LeftLogo} alt="Left Logo" className="top-logo" />
          <img src={TagLine} alt="Tagline Logo" className="tagline-logo" />
          <img src={RightLogo} alt="Right Logo" className="top-logo" />
        </div>
        {/* Sticky Tabs */}
        <div className="ai-tabs-bar">
          <button
            className={activeTab === "About" ? "active-tab" : ""}
            onClick={() => handleTabClick("About", aboutRef)}
          >
            About
          </button>

          <button
            className={activeTab === "Timeline" ? "active-tab" : ""}
            onClick={() => handleTabClick("Timeline", timelineRef)}
          >
            Timeline
          </button>

          <button
            className={activeTab === "Objectives" ? "active-tab" : ""}
            onClick={() => handleTabClick("Objectives", objectivesRef)}
          >
            Objectives
          </button>
          <button
            className={activeTab === "Thematic Areas" ? "active-tab" : ""}
            onClick={() => handleTabClick("Thematic Areas", thematicareasRef)}
          >
            Thematic Areas
          </button>
          <button
            className={activeTab === "Evaluation" ? "active-tab" : ""}
            onClick={() => handleTabClick("Evaluation", evaluationRef)}
          >
            Evaluation
          </button>
          <button
            className={activeTab === "Partners" ? "active-tab" : ""}
            onClick={() => handleTabClick("Partners", partnersRef)}
          >
            Partners
          </button>

          <button
            className={activeTab === "Guidelines" ? "active-tab" : ""}
            onClick={() => handleTabClick("Guidelines", guidelinesRef)}
          >
            Guidelines
          </button>
          <button
            className={activeTab === "Results" ? "active-tab" : ""}
            onClick={() => handleTabClick("Results", resultsRef)}
          >
            Results
          </button>
          <button
            className={activeTab === "Gallery" ? "active-tab" : ""}
            onClick={() => handleTabClick("Gallery", galleryRef)}
          >
            Gallery
          </button>
        </div>

        <div className="ai-register-section">
          <h3 className="ai-countdown">
            {isRegistrationActive ? (
              <>
                Registration Closes In:{" "}
                <span>
                  {timeLeft.days}d {timeLeft.hours}h {timeLeft.minutes}m{" "}
                  {timeLeft.seconds}s
                </span>
              </>
            ) : (
              <>Registration Closed</>
            )}
          </h3>

          <a
            href="https://forms.gle/G2gyPzUrNZiH1aBGA"
            target="_blank"
            rel="noopener noreferrer"
          >
            <button className="register-btn" disabled={!isRegistrationActive}>
              Get Registered
            </button>
          </a>
        </div>
        <p className="cash-prize">
          <span className="label">🏆 Cash Prize:</span>
          <span className="amount"> ₨ 11.25 Million</span>
        </p>

        {/* Hero Banner */}
        <div className="ai-hero">
          <img
            src={AIcomp}
            alt="AI Competition"
            className="ai-wrapper-banner"
          />
        </div>

        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <h1>AI Wrapper Competition - The Journey</h1>
          <div
            style={{
              width: "100%",
              maxWidth: "560px", // max size 560px
              margin: "0 auto",
            }}
          >
            <iframe
              src="https://www.youtube.com/embed/Lcml4cuSd0I"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              style={{
                width: "100%",
                height: "315px", // fixed height for original aspect ratio
                maxWidth: "100%", // responsive
              }}
            ></iframe>
          </div>
        </div>

        {/* Graph Section */}
        <div className="graph-section">
          <h2 className="graph-title">REGISTRATION INSIGHTS </h2>
          <img
            src={Graph}
            alt="Competition Highlights"
            className="graph-image"
          />
        </div>

        {/* All Sections */}
        <div className="ai-tab-content">
          {/* About */}
          <div ref={aboutRef} className="ai-section">
            <p>
              The AI Wrapper Competition 2025, under the Digital Pakistan
              initiative, is a national-level challenge aiming to identify and
              promote AI-based solutions tailored to local challenges in
              Pakistan. This strategic initiative is aligned with Pakistan’s
              National AI Policy by fostering a skilled workforce, promoting
              ethical and explainable AI, and catalysing civic innovation in
              EdTech, Health-Tech, Gov-Tech, Fin-Tech and Climate-Tech.
            </p>
            <p>
              By mobilizing AI wrapper fellows and creating a pipeline of
              deployable solutions, it builds national capacity for real world
              AI adoption. Internationally, it meets global standards by
              leveraging cloud infrastructure, open datasets, and cross-sector
              collaboration. The competition elevates Pakistan’s AI profile by
              preparing teams for global stage reinforcing a sustainable,
              inclusive, and innovation-driven digital ecosystem.
            </p>
          </div>

          {/* Timeline */}
          <div ref={timelineRef} className="ai-section">
            <h2>TIMELINE</h2>
            <div className="timeline-table-wrapper">
              <table className="timeline-table">
                <thead>
                  <tr>
                    <th>Activity</th>
                    <th>Location</th>
                    <th>Dates</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td data-label="Activity">Regional Round – 1</td>
                    <td data-label="Location">NIC-Islamabad</td>
                    <td data-label="Dates">22-23 October , 2025</td>
                  </tr>
                  <tr>
                    <td data-label="Activity">Regional Round – 2</td>
                    <td data-label="Location">NIC-Peshawar</td>
                    <td data-label="Dates">27 October , 2025</td>
                  </tr>
                  <tr>
                    <td data-label="Activity">Regional Round – 3</td>
                    <td data-label="Location">NIC-Quetta</td>
                    <td data-label="Dates">27 October , 2025</td>
                  </tr>
                  <tr>
                    <td data-label="Activity">Regional Round – 4</td>
                    <td data-label="Location">NIC-Karachi</td>
                    <td data-label="Dates">30 October - 31 October , 2025</td>
                  </tr>
                  <tr>
                    <td data-label="Activity">Regional Round – 5</td>
                    <td data-label="Location">NIC-Lahore</td>
                    <td data-label="Dates">4-5 November , 2025</td>
                  </tr>
                  <tr>
                    <td data-label="Activity">Grand Finale</td>
                    <td data-label="Location">NIC-Islamabad</td>
                    <td data-label="Dates">11 November , 2025</td>
                  </tr>
                  <tr>
                    <td data-label="Activity">Award Ceremony</td>
                    <td data-label="Location">Islamabad</td>
                    <td data-label="Dates">13 November , 2025</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Objectives */}
          <div ref={objectivesRef} className="ai-section">
            <h2>OBJECTIVES</h2>
            <ul>
              <li>To promote AI innovation in proposed thematic areas</li>
              <li>
                To build a community of 500+ AI fellows and identify 25+
                prototypes/solutions
              </li>
              <li>
                To inspire public sector digital transformation through scalable
                solutions
              </li>
              <li>
                To support entrepreneurship and incubation pathways for young
                innovators
              </li>
              <li>
                To position Pakistan in global AI landscape (AI for Good,
                NeurIPS)
              </li>
              <li>To foster government–industry–academia collaboration</li>
            </ul>
          </div>

          {/* Domains */}
          <div ref={thematicareasRef} className="ai-section">
            <h2>THEMATIC AREAS</h2>
            <p>
              Participants will be required to address real local challenges:
            </p>
            <div className="ai-cards">
              {/* Education */}
              <div className="ai-card">
                <img src={ETech} alt="EdTech Logo" className="domain-logo" />
                <h3>Education (Ed-Tech)</h3>
                <ul>
                  <li>
                    Digital access to quality education in underserved regions
                  </li>
                  <li>Personalized learning & adaptive assessment</li>
                  <li>AI-powered learning analytics to improve outcomes</li>
                  <li>Accessibility for students with special needs</li>
                </ul>
              </div>
              {/* Health */}
              <div className="ai-card">
                <img
                  src={HTech}
                  alt="HealthTech Logo"
                  className="domain-logo"
                />
                <h3>Health (Health-Tech)</h3>
                <ul>
                  <li>Early disease detection </li>
                  <li>Health record digitization & predictive analytics</li>
                  <li>Remote diagnostics & telemedicine AI solutions</li>
                  <li>AI-assisted drug interaction & prescription safety</li>
                </ul>
              </div>
              {/* Governance */}
              <div className="ai-card">
                <img src={GTech} alt="GovTech Logo" className="domain-logo" />
                <h3>Governance (Gov-Tech)</h3>
                <ul>
                  <li>Citizen service automation & complaint redressal</li>
                  <li>AI-driven policy decision support systems</li>
                  <li>Fraud detection in tax, subsidies & public finance</li>
                  <li>Transparency & accountability tools </li>
                </ul>
              </div>

              {/* Climate */}
              <div className="ai-card">
                <img
                  src={CTech}
                  alt="ClimateTech Logo"
                  className="domain-logo"
                />
                <h3>Climate (Climate-Tech)</h3>
                <ul>
                  <li>AI-powered disaster prediction & response planning</li>
                  <li>Air quality monitoring & public health advisories</li>
                  <li>AI for climate-driven agricultural planning</li>
                  <li>
                    Flood/drought risk analysis using satellite & IoT data
                  </li>
                </ul>
              </div>
              {/* Finance */}
              <div className="ai-card">
                <img src={FTech} alt="FinTech Logo" className="domain-logo" />
                <h3>Finance (Fin-Tech)</h3>
                <ul>
                  <li>Tax fraud & anomaly detection</li>
                  <li>Smart complaint classification</li>
                  <li>License & permit automation</li>
                  <li>AI driven credit scoring & risk analysis</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Evaluation */}
          <div ref={evaluationRef} className="ai-section">
            <h2>EVALUATION PROCESS</h2>
            <ul className="ai-criteria">
              <li>
                Initial assessment will be conducted to verify eligibility,
                completeness, and compliance
              </li>
              <li>
                Regional Round Evaluation: A panel of judges will assess
                domain-specific projects and assign score based on the
                prescribed evaluation matrix
              </li>
              <li>
                Final Round Evaluation: A panel of judges will assess
                domain-specific projects with increased emphasis on working
                prototypes and scalability
              </li>
            </ul>

            <h2>Evaluation Criteria:</h2>
            <ul className="ai-criteria">
              <li>
                <strong>Problem Relevance (15%)</strong>
                <br />
                Alignment with local context & domain challenges
              </li>
              <li>
                <strong>Innovation & Creativity (20%)</strong>
                <br />
                Originality and novelty of the solution
              </li>
              <li>
                <strong>Technical Feasibility (15%)</strong>
                <br />
                Architecture, algorithms, data handling
              </li>
              <li>
                <strong>Use of Local Datasets (10%)</strong>
                <br />
                Preference to validated local/national datasets
              </li>
              <li>
                <strong>Impact Potential (15%)</strong>
                <br />
                Scalability, replicability, societal/economic benefits
              </li>
              <li>
                <strong>Presentation & Communication (5%)</strong>
                <br />
                Clarity and persuasiveness during pitching
              </li>
              <li>
                <strong>Prototype Functionality (15%)</strong>
                <br />
                Working demonstration, accuracy and usability
              </li>
              <li>
                <strong>Ethical Compliance (5%)</strong>
                <br />
                Privacy, bias avoidance, responsible AI
              </li>
            </ul>
          </div>

          {/* Partners */}
          <div ref={partnersRef} className="ai-section">
            <div className="ai-section">
              <h2>OUR PARTNERS</h2>
              {/* <p>We proudly collaborate with our amazing partners:</p> */}
              <div className="ai-cards-partners">
                {/* Row 1 */}
                <div className="aicard">
                  <img
                    src={Partner2}
                    alt="Partner 2 Logo"
                    className="domain-logos"
                  />
                </div>
                <div className="aicard">
                  <img
                    src={Partner3}
                    alt="Partner 3 Logo"
                    className="domain-logos"
                  />
                </div>
                <div className="aicard">
                  <img
                    src={Partner4}
                    alt="Partner 4 Logo"
                    className="domain-logos"
                  />
                </div>

                {/* Row 2 */}
                <div className="aicard">
                  <img
                    src={Partner5}
                    alt="Partner 5 Logo"
                    className="domain-logos"
                  />
                </div>
                <div className="aicard">
                  <img
                    src={Partner11}
                    alt="Partner 11 Logo"
                    className="domain-logos"
                  />
                </div>
                <div className="aicards">
                  <img
                    src={Partner6}
                    alt="Partner 6 Logo"
                    className="my-logos"
                  />
                </div>
                <div className="aicards">
                  <img
                    src={Partner7}
                    alt="Partner 7 Logo"
                    className="my-logos"
                  />
                </div>
                <div className="aicards">
                  <img
                    src={Partner8}
                    alt="Partner 8 Logo"
                    className="my-logos"
                  />
                </div>
                <div className="aicards">
                  <img
                    src={Partner9}
                    alt="Partner 9 Logo"
                    className="my-logos"
                  />
                </div>
                <div className="aicards">
                  <img
                    src={Partner10}
                    alt="Partner 10 Logo"
                    className="my-logos"
                  />
                </div>
                <div className="aicards">
                  <img
                    src={Partner12}
                    alt="Partner 12 Logo"
                    className="my-logos"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Guidelines */}

          <div ref={guidelinesRef} className="ai-section">
            <h2>GUIDELINES FOR PARTICIPANTS</h2>
            <ul>
              <li>
                Each team will consist of up to 2 members (individuals can also
                apply)
              </li>
              <li>
                Competition is open to all citizens of Pakistan – students,
                faculty, researchers, industry professionals, entrepreneurs etc.
              </li>
              <li>Team compete in one or more thematic area</li>
              <li>Solution(s) must address local challenge(s) in Pakistan</li>
              <li>
                Both Regional and Final rounds require working prototypes (or
                functional MVPs)
              </li>
              <li>
                Participant(s) must arrange all resources (hardware, software,
                datasets, compute etc.) themselves required for solution
                development
              </li>
              <li>
                Datasets may be global, however locally validated datasets
                (sources of data) from national institutions are preferred
              </li>
              <li>
                The core AI model or wrapper integration must be developed by
                the team; off-the-shelf solutions without significant
                customization will be disqualified
              </li>
              <li>
                Solutions must follow ethical AI principles: transparency,
                fairness, privacy compliance
              </li>
              <li>
                All intellectual property will belong to the participants, with
                due acknowledgment to Ignite
              </li>
              <li>
                One Minute (60 Sec only) Video Link of the Product/Concept
                depicting all possible aspects of AI Wrapper should be uploaded
              </li>
            </ul>

            <h2>CORE TECHNICAL INCLUSIONS FOR AI WRAPPER SOLUTIONS</h2>
            <p>
              The following checkpoints will be used to validate the AI Wrapper
              solution:
            </p>
            <h1>1. Base Model Integration</h1>
            <ul>
              <li>
                Ability to connect with foundational models (i.e LLMs, Datasets,
                vision models, speech models etc.)
              </li>
              <li>
                Support for multiple APIs/frameworks (OpenAI, OpenCV, Hugging
                Face, LangChain, local LLMs etc.)
              </li>
            </ul>

            <h1>2. Abstraction Layer (Wrapper Logic)</h1>
            <ul>
              <li>
                Standardized API endpoints for model requests and responses
              </li>
              <li>
                Middleware that handles prompts, input parsing, and response
                normalization
              </li>
            </ul>

            <h1>3. Multi-Modal Support (if applicable)</h1>
            <ul>
              <li>Text, Image, Audio, Video data handling</li>
              <li>
                Unified processing pipeline for different input/output formats
              </li>
            </ul>

            <h1>4. Orchestration & Multi-Agent Support</h1>
            <ul>
              <li>
                Task decomposition and agent collaboration (i.e planner,
                executor, verifier agents etc.)
              </li>
              <li>Workflow management for chaining multiple AI tasks</li>
            </ul>

            <h1>5. Data Handling & Pre-/Post-Processing</h1>
            <ul>
              <li>Input sanitization, formatting, embedding generation</li>
              <li>
                Post-response refinement (validation, summarization, ranking)
              </li>
            </ul>

            <h1>6. Evaluation & Benchmarking Module</h1>
            <ul>
              <li>
                Built-in evaluation metrics (accuracy, latency, hallucination
                detection)
              </li>
              <li>Logging of model performance across tasks</li>
            </ul>

            <h1>7. Scalability & Deployment Readiness</h1>
            <ul>
              <li>Containerized deployment (Docker, Kubernetes)</li>
              <li>Cloud-native compatibility (AWS, GCP, Azure)</li>
            </ul>

            <h1>8. Security & Compliance</h1>
            <ul>
              <li>Secure API calls with authentication</li>
              <li>Data privacy compliance (GDPR-like rules)</li>
              <li>Prompt injection defense and content filtering</li>
            </ul>

            <h1>9. Extensibility</h1>
            <ul>
              <li>
                Plugin system for integrating external tools (i.e search
                engines, databases etc.)
              </li>
              <li>
                Support for connecting with enterprise applications (ERP, CRM,
                BI tools)
              </li>
            </ul>

            <h1>10. Monitoring & Analytics</h1>
            <ul>
              <li>Real-time logs and dashboards for API usage</li>
              <li>
                Error tracking, model drift detection, and system health checks
              </li>
            </ul>

            <h1>11. Documentation & Standardization</h1>
            <ul>
              <li>Well-documented SDKs/APIs</li>
              <li>Standard input-output schemas for interoperability</li>
            </ul>
          </div>

          {/* ===== Results Section ===== */}

          <section ref={resultsRef} id="results" className="results-section">
            <h3 style={{ fontStyle: "italic" }}>
              "First AI Wrapper Competition 2025 - Build for Impact, Compete for
              Recognition, Lead the AI Revolution."
            </h3>
            <h2>National Winners</h2>
            <table className="results-table">
              <thead>
                <tr>
                  <th>Rank</th>
                  <th>Project Title</th>
                  <th>Team Name</th>
                  <th>City</th>
                </tr>
              </thead>
              <tbody>
                {/* ISLAMABAD */}
                <tr>
                  <td
                    colSpan="3"
                    style={{ fontWeight: "bold", textAlign: "left" }}
                  >
                    ED-TECH
                  </td>
                </tr>
                <tr style={{ fontWeight: "bold" }}>
                  <td>1</td>
                  <td>EVA-00 by Edversity</td>
                  <td>Edversity</td>
                  <td>Islamabad</td>
                </tr>
                <tr style={{ fontWeight: "bold" }}>
                  <td>2</td>
                  <td>Critshot</td>
                  <td>Chrio</td>
                  <td>Islamabad</td>
                </tr>
                <tr style={{ fontWeight: "bold" }}>
                  <td>3</td>
                  <td>MyPath</td>
                  <td>MyPath</td>
                  <td>Lahore</td>
                </tr>

                {/* QUETTA */}
                <tr>
                  <td
                    colSpan="3"
                    style={{ fontWeight: "bold", textAlign: "left" }}
                  >
                    HEALTH-TECH
                  </td>
                </tr>
                <tr style={{ fontWeight: "bold" }}>
                  <td>1</td>
                  <td>DxVision AI</td>
                  <td>DxVision AI</td>
                  <td>Islamabad</td>
                </tr>
                <tr style={{ fontWeight: "bold" }}>
                  <td>2</td>
                  <td>Smart DiabiCare</td>
                  <td>CareSynapse</td>
                  <td>Islamabad</td>
                </tr>
                <tr style={{ fontWeight: "bold" }}>
                  <td>3</td>
                  <td>RunVerse</td>
                  <td>Z Media Technologies</td>
                  <td>Islamabad</td>
                </tr>

                {/* PESHAWAR */}
                <tr>
                  <td
                    colSpan="3"
                    style={{ fontWeight: "bold", textAlign: "left" }}
                  >
                    FIN-TECH
                  </td>
                </tr>
                <tr style={{ fontWeight: "bold" }}>
                  <td>1</td>
                  <td>Portfolio Optimizer Pro</td>
                  <td>Quant Fusion Analytics</td>
                  <td>Rawalpindi</td>
                </tr>
                <tr style={{ fontWeight: "bold" }}>
                  <td>2</td>
                  <td>OfficeflowAI</td>
                  <td>OfficeflowAI</td>
                  <td>Islamabad</td>
                </tr>
                <tr style={{ fontWeight: "bold" }}>
                  <td>3</td>
                  <td>AFIW–ZulfiQode</td>
                  <td>Mir Global AI La</td>
                  <td>Islamabad</td>
                </tr>

                {/* Karachi */}
                <tr>
                  <td
                    colSpan="3"
                    style={{ fontWeight: "bold", textAlign: "left" }}
                  >
                    AGRI/CLIMATE-TECH
                  </td>
                </tr>

                {/* 🥇 Top scorers (bold) */}
                <tr style={{ fontWeight: "bold" }}>
                  <td>1</td>
                  <td>KissanBot: AI Farmer Assistant</td>
                  <td>Concave AGRI</td>
                  <td>Islamabad</td>
                </tr>
                <tr style={{ fontWeight: "bold" }}>
                  <td>2</td>
                  <td>GeoGemma | Google Research</td>
                  <td>Team GeoGemma</td>
                  <td>Islamabad</td>
                </tr>
                <tr style={{ fontWeight: "bold" }}>
                  <td>3</td>
                  <td>WeatherSense</td>
                  <td>LeObran</td>
                  <td>Rawalpindi</td>
                </tr>

                {/* Lahore */}
                <tr>
                  <td
                    colSpan="3"
                    style={{ fontWeight: "bold", textAlign: "left" }}
                  >
                    GOV-TECH
                  </td>
                </tr>

                {/* 🥇 Top 3 (bold + *) */}
                <tr style={{ fontWeight: "bold" }}>
                  <td>1</td>
                  <td>PakLawAssist</td>
                  <td>PakLawAssist</td>
                  <td>Lahore</td>
                </tr>
                <tr style={{ fontWeight: "bold" }}>
                  <td>2</td>
                  <td>OwlSense</td>
                  <td>Rapidev Group</td>
                  <td>Islamabad</td>
                </tr>
                <tr style={{ fontWeight: "bold" }}>
                  <td>3</td>
                  <td>AI-Powered Archival Management System</td>
                  <td>DocInsight</td>
                  <td>Quetta</td>
                </tr>
              </tbody>
            </table>

            <h2>Finalists of AI Wrapper Competition 2025</h2>
            <p className="note">Top teams in each category are shown below.</p>
            <p className="note">
              * Teams are elegible to compete in the Grand Finale.
            </p>

            {/* 🧠 ED-TECH */}
            <h3>ED-TECH</h3>
            <table className="results-table">
              <thead>
                <tr>
                  <th>Rank</th>
                  <th>Project Title</th>
                  <th>Team Name</th>
                </tr>
              </thead>
              <tbody>
                {/* ISLAMABAD */}
                <tr>
                  <td
                    colSpan="3"
                    style={{ fontWeight: "bold", textAlign: "left" }}
                  >
                    ISLAMABAD
                  </td>
                </tr>
                <tr style={{ fontWeight: "bold" }}>
                  <td>1</td>
                  <td>Critshot *</td>
                  <td>Chrio</td>
                </tr>
                <tr style={{ fontWeight: "bold" }}>
                  <td>2</td>
                  <td>TrevaTutor *</td>
                  <td>Treva</td>
                </tr>
                <tr style={{ fontWeight: "bold" }}>
                  <td>3</td>
                  <td>EVA-00 by Edversity *</td>
                  <td>Edversity</td>
                </tr>
                <tr style={{ fontWeight: "bold" }}>
                  <td>4</td>
                  <td>Prompttoons *</td>
                  <td>cartoons</td>
                </tr>

                {/* QUETTA */}
                <tr>
                  <td
                    colSpan="3"
                    style={{ fontWeight: "bold", textAlign: "left" }}
                  >
                    QUETTA
                  </td>
                </tr>
                <tr style={{ fontWeight: "bold" }}>
                  <td>1</td>
                  <td>Signify *</td>
                  <td>Team Prism</td>
                </tr>
                <tr style={{ fontWeight: "bold" }}>
                  <td>2</td>
                  <td>AI Teaching Assistant *</td>
                  <td>SmartLearn Innovators</td>
                </tr>
                <tr style={{ fontWeight: "bold" }}>
                  <td>3</td>
                  <td>
                    Neurolingo: A Natural Language Translator from English to
                    Balochi *
                  </td>
                  <td>Team BalochiAI</td>
                </tr>

                {/* PESHAWAR */}
                <tr>
                  <td
                    colSpan="3"
                    style={{ fontWeight: "bold", textAlign: "left" }}
                  >
                    PESHAWAR
                  </td>
                </tr>
                <tr style={{ fontWeight: "bold" }}>
                  <td>1</td>
                  <td>STEAM MINDS *</td>
                  <td>STEAM MINDs</td>
                </tr>
                <tr style={{ fontWeight: "bold" }}>
                  <td>2</td>
                  <td>Chameleon *</td>
                  <td>Al Makr Allah</td>
                </tr>

                {/* Karachi */}
                <tr>
                  <td
                    colSpan="3"
                    style={{ fontWeight: "bold", textAlign: "left" }}
                  >
                    KARACHI
                  </td>
                </tr>

                {/* 🥇 Top scorers (bold) */}
                <tr style={{ fontWeight: "bold" }}>
                  <td>1</td>
                  <td>SkillsBridge *</td>
                  <td>Tech Titans</td>
                </tr>
                <tr style={{ fontWeight: "bold" }}>
                  <td>2</td>
                  <td>SymposAI *</td>
                  <td>DivDash</td>
                </tr>
                <tr style={{ fontWeight: "bold" }}>
                  <td>3</td>
                  <td>Gradex-AI *</td>
                  <td>GradexAI</td>
                </tr>

                {/* Lahore */}
                <tr>
                  <td
                    colSpan="3"
                    style={{ fontWeight: "bold", textAlign: "left" }}
                  >
                    LAHORE
                  </td>
                </tr>

                {/* 🥇 Top 3 (bold + *) */}
                <tr style={{ fontWeight: "bold" }}>
                  <td>1</td>
                  <td>MyPath *</td>
                  <td>MyPath</td>
                </tr>
                <tr style={{ fontWeight: "bold" }}>
                  <td>2</td>
                  <td>StudocAI *</td>
                  <td>StudocAI</td>
                </tr>
                <tr style={{ fontWeight: "bold" }}>
                  <td>3</td>
                  <td>Heyeve.ai *</td>
                  <td>Heyeve</td>
                </tr>
              </tbody>
            </table>

            {/* health-tech */}
            <h3>HEALTH-TECH</h3>
            <table className="results-table">
              <thead>
                <tr>
                  <th>Rank</th>
                  <th>Project Title</th>
                  <th>Team Name</th>
                </tr>
              </thead>
              <tbody>
                {/* Islamabad */}
                <tr>
                  <td
                    colSpan="3"
                    style={{ fontWeight: "bold", textAlign: "left" }}
                  >
                    ISLAMABAD
                  </td>
                </tr>

                {/* 🥇 Top scorers (bold) */}
                <tr style={{ fontWeight: "bold" }}>
                  <td>1</td>
                  <td>DxVision AI *</td>
                  <td>DxVision AI</td>
                </tr>
                <tr style={{ fontWeight: "bold" }}>
                  <td>2</td>
                  <td>RunVerse *</td>
                  <td>Z Media Technologies</td>
                </tr>
                <tr style={{ fontWeight: "bold" }}>
                  <td>3</td>
                  <td>Smart DiabiCare *</td>
                  <td>CareSynapse</td>
                </tr>

                {/* Peshawar */}
                <tr>
                  <td
                    colSpan="3"
                    style={{ fontWeight: "bold", textAlign: "left" }}
                  >
                    PESHAWAR
                  </td>
                </tr>

                {/* 🥇 Top scorers (bold) */}
                <tr style={{ fontWeight: "bold" }}>
                  <td>1</td>
                  <td>RetinaMind: AI-Based Alzheimer’s Predictor *</td>
                  <td>Eye2AI</td>
                </tr>
                <tr style={{ fontWeight: "bold" }}>
                  <td>2</td>
                  <td>
                    Exploring the Neurosky Wave Brain Wave Sensor Application
                    for wheel chair *
                  </td>
                  <td>Brain Technology</td>
                </tr>
                <tr style={{ fontWeight: "bold" }}>
                  <td>3</td>
                  <td>
                    NEUROSTRIDE: Brain-Controlled Walker for Cerebral Palsy and
                    Rehabilitation *
                  </td>
                  <td>Brian Tech</td>
                </tr>

                {/* KARACHI */}
                <tr>
                  <td
                    colSpan="3"
                    style={{ fontWeight: "bold", textAlign: "left" }}
                  >
                    KARACHI
                  </td>
                </tr>

                {/* 🥇 Top 3 scorers (bold) */}
                <tr style={{ fontWeight: "bold" }}>
                  <td>1</td>
                  <td>Suno Pakistan: Bridging Voices with AI *</td>
                  <td>Abdullah Sabahat</td>
                </tr>
                <tr style={{ fontWeight: "bold" }}>
                  <td>2</td>
                  <td>GlycoCare — AI Food & Glucose Analyzer *</td>
                  <td>Silent Shadow</td>
                </tr>
                <tr style={{ fontWeight: "bold" }}>
                  <td>3</td>
                  <td>Emergency Services Call bot *</td>
                  <td>SOS</td>
                </tr>

                {/* LAHORE */}
                <tr>
                  <td
                    colSpan="3"
                    style={{ fontWeight: "bold", textAlign: "left" }}
                  >
                    LAHORE
                  </td>
                </tr>

                {/* 🥇 Top 3 (bold + *) */}
                <tr style={{ fontWeight: "bold" }}>
                  <td>1</td>
                  <td>Go - *</td>
                  <td>MyndEdge</td>
                </tr>
                <tr style={{ fontWeight: "bold" }}>
                  <td>2</td>
                  <td>Ocularis *</td>
                  <td>HMAT Team</td>
                </tr>
                <tr style={{ fontWeight: "bold" }}>
                  <td>3</td>
                  <td>
                    Unsupervised Domain Adaptation for AI in Healthcare &amp;
                    Education *
                  </td>
                  <td>DomainAI Innovators</td>
                </tr>
              </tbody>
            </table>

            {/* Fin-tech */}
            <h3>FIN-TECH</h3>
            <table className="results-table">
              <thead>
                <tr>
                  <th>Rank</th>
                  <th>Project Title</th>
                  <th>Team Name</th>
                </tr>
              </thead>
              <tbody>
                {/* ISLAMABAD */}
                <tr>
                  <td
                    colSpan="3"
                    style={{ fontWeight: "bold", textAlign: "left" }}
                  >
                    ISLAMABAD
                  </td>
                </tr>

                {/* 🥇 Top scorers (bold) */}
                <tr style={{ fontWeight: "bold" }}>
                  <td>1</td>
                  <td>OfficeflowAI Fintech *</td>
                  <td>Officeflow AI</td>
                </tr>
                <tr style={{ fontWeight: "bold" }}>
                  <td>2</td>
                  <td>Alpha Lens *</td>
                  <td>Team Alpha lens</td>
                </tr>
                <tr style={{ fontWeight: "bold" }}>
                  <td>3</td>
                  <td>Portfolio Optimizer Pro *</td>
                  <td>Quant Fusion Analytics</td>
                </tr>

                {/* PESHAWAR */}
                <tr>
                  <td
                    colSpan="3"
                    style={{ fontWeight: "bold", textAlign: "left" }}
                  >
                    PESHAWAR
                  </td>
                </tr>

                <tr style={{ fontWeight: "bold" }}>
                  <td>1</td>
                  <td>Zulficode *</td>
                  <td>Fintech</td>
                </tr>
              </tbody>
            </table>

            {/* Agri/Clim-Tech */}
            <h3>AGRI/CLIMATE-TECH</h3>
            <table className="results-table">
              <thead>
                <tr>
                  <th>Rank</th>
                  <th>Project Title</th>
                  <th>Team Name</th>
                </tr>
              </thead>
              <tbody>
                {/* ISLAMABAD */}
                <tr>
                  <td
                    colSpan="3"
                    style={{ fontWeight: "bold", textAlign: "left" }}
                  >
                    ISLAMABAD
                  </td>
                </tr>

                {/* 🥇 Top scorers (bold) */}
                <tr style={{ fontWeight: "bold" }}>
                  <td>1</td>
                  <td>KissanBot (AI Farmer Assistant) *</td>
                  <td>ConcaveAgri</td>
                </tr>
                <tr style={{ fontWeight: "bold" }}>
                  <td>2</td>
                  <td>GeoGemma | Google Research *</td>
                  <td>Team GeoGemma</td>
                </tr>
                <tr style={{ fontWeight: "bold" }}>
                  <td>3</td>
                  <td>WeatherSense *</td>
                  <td>LeObran</td>
                </tr>

                {/* PESHAWAR */}
                <tr>
                  <td
                    colSpan="3"
                    style={{ fontWeight: "bold", textAlign: "left" }}
                  >
                    PESHAWAR
                  </td>
                </tr>
                <tr style={{ fontWeight: "bold" }}>
                  <td>1</td>
                  <td>KisanAI Advisor *</td>
                  <td>Fixers</td>
                </tr>

                {/* KARACHI */}
                <tr>
                  <td
                    colSpan="3"
                    style={{ fontWeight: "bold", textAlign: "left" }}
                  >
                    KARACHI
                  </td>
                </tr>

                {/* 🥇 Top 3 scorers (bold) */}
                <tr style={{ fontWeight: "bold" }}>
                  <td>1</td>
                  <td>
                    An intelligent RAG-based chatbot system for Sindh's
                    sustainable climate actions *
                  </td>
                  <td>Sustainovators</td>
                </tr>
                <tr style={{ fontWeight: "bold" }}>
                  <td>2</td>
                  <td>Deforestation Detection Using Satellite Imagery *</td>
                  <td>Solo Circle</td>
                </tr>
                <tr style={{ fontWeight: "bold" }}>
                  <td>3</td>
                  <td>DroneMate AI *</td>
                  <td>AeroSpace</td>
                </tr>
              </tbody>
            </table>

            {/* Gov-Tech */}
            <h3>GOV-TECH</h3>
            <table className="results-table">
              <thead>
                <tr>
                  <th>Rank</th>
                  <th>Project Title</th>
                  <th>Team Name</th>
                </tr>
              </thead>
              <tbody>
                {/* ISLAMABAD */}
                <tr>
                  <td
                    colSpan="3"
                    style={{ fontWeight: "bold", textAlign: "left" }}
                  >
                    ISLAMABAD
                  </td>
                </tr>

                <tr style={{ fontWeight: "bold" }}>
                  <td>1</td>
                  <td>
                    OwlSense – AI-Powered Governance & Anti-Disinformation
                    Platform *
                  </td>
                  <td>Rapidev Group - OwlSense</td>
                </tr>
                <tr style={{ fontWeight: "bold" }}>
                  <td>2</td>
                  <td>
                    Real-Time Multi-Modal Media Intelligence System for
                    Governance *
                  </td>
                  <td>AITeC</td>
                </tr>
                <tr style={{ fontWeight: "bold" }}>
                  <td>3</td>
                  <td>AI Layer for Video Surveillance *</td>
                  <td>Amal Axis</td>
                </tr>

                {/* QUETTA */}
                <tr>
                  <td
                    colSpan="3"
                    style={{ fontWeight: "bold", textAlign: "left" }}
                  >
                    QUETTA
                  </td>
                </tr>
                <tr style={{ fontWeight: "bold" }}>
                  <td>1</td>
                  <td>AI-Powered Archival Management System *</td>
                  <td>DocInsight</td>
                </tr>
                <tr style={{ fontWeight: "bold" }}>
                  <td>2</td>
                  <td>
                    RUNER-1: A Benchmark Dataset for Roman Urdu NER with a
                    Transformer-Based Approach *
                  </td>
                  <td>TokenHunt</td>
                </tr>

                {/* PESHAWAR */}
                <tr>
                  <td
                    colSpan="3"
                    style={{ fontWeight: "bold", textAlign: "left" }}
                  >
                    PESHAWAR
                  </td>
                </tr>
                <tr style={{ fontWeight: "bold" }}>
                  <td>1</td>
                  <td>Public Health Advisory & Citizen Engagement App *</td>
                  <td>PakAir-SehatAwaz</td>
                </tr>

                {/* KARACHI */}
                <tr>
                  <td
                    colSpan="3"
                    style={{ fontWeight: "bold", textAlign: "left" }}
                  >
                    KARACHI
                  </td>
                </tr>
                <tr style={{ fontWeight: "bold" }}>
                  <td>1</td>
                  <td>SOCByte *</td>
                  <td>Team SOCByte</td>
                </tr>
                <tr style={{ fontWeight: "bold" }}>
                  <td>2</td>
                  <td>AI Driven DevOps Automation *</td>
                  <td>Cheromo</td>
                </tr>
                <tr style={{ fontWeight: "bold" }}>
                  <td>3</td>
                  <td>AI Powered Zero Day Attack Detection *</td>
                  <td>Team Dev</td>
                </tr>

                {/* LAHORE */}
                <tr>
                  <td
                    colSpan="3"
                    style={{ fontWeight: "bold", textAlign: "left" }}
                  >
                    LAHORE
                  </td>
                </tr>

                {/* 🥇 Top 3 (bold + *) */}
                <tr style={{ fontWeight: "bold" }}>
                  <td>1</td>
                  <td>PakLawAssist *</td>
                  <td>PakLawAssist</td>
                </tr>
                <tr style={{ fontWeight: "bold" }}>
                  <td>2</td>
                  <td>Hsieh AI *</td>
                  <td>Hsieh AI</td>
                </tr>
                <tr style={{ fontWeight: "bold" }}>
                  <td>3</td>
                  <td>CivicFlow AI *</td>
                  <td>Team NeuralNation</td>
                </tr>
              </tbody>
            </table>
          </section>

          {/* Gallery */}
          <div ref={galleryRef} className="ai-section">
            <h2>Gallery</h2>
            <div className="gallery-grid">
              <img src={Isb1} alt="Gallery" className="gallery-img" />
              <img src={Isb2} alt="Gallery" className="gallery-img" />
              <img src={Isb3} alt="Gallery" className="gallery-img" />

              <img src={Que1} alt="Gallery" className="gallery-img" />
              <img src={Que2} alt="Gallery" className="gallery-img" />
              <img src={Que3} alt="Gallery" className="gallery-img" />

              <img src={Pew1} alt="Gallery" className="gallery-img" />
              <img src={Pew2} alt="Gallery" className="gallery-img" />
              <img src={Pew3} alt="Gallery" className="gallery-img" />

              <img src={Khi1} alt="Gallery" className="gallery-img" />
              <img src={Khi2} alt="Gallery" className="gallery-img" />
              <img src={Khi3} alt="Gallery" className="gallery-img" />

              <img src={Lhr1} alt="Gallery" className="gallery-img" />
              <img src={Lhr2} alt="Gallery" className="gallery-img" />
              <img src={Lhr3} alt="Gallery" className="gallery-img" />

              <img src={win1} alt="Gallery" className="gallery-img" />
              <img src={win2} alt="Gallery" className="gallery-img" />
              <img src={win3} alt="Gallery" className="gallery-img" />
              <img src={win4} alt="Gallery" className="gallery-img" />
              <img src={win5} alt="Gallery" className="gallery-img" />
              <img src={win} alt="Gallery" className="gallery-img" />

              <img src={Rup11} alt="Gallery" className="gallery-img" />
              <img src={Rup12} alt="Gallery" className="gallery-img" />
              <img src={Rup13} alt="Gallery" className="gallery-img" />
              <img src={Rup14} alt="Gallery" className="gallery-img" />
              <img src={Rup15} alt="Gallery" className="gallery-img" />

              <img src={Rup21} alt="Gallery" className="gallery-img" />
              <img src={Rup22} alt="Gallery" className="gallery-img" />
              <img src={Rup23} alt="Gallery" className="gallery-img" />
              <img src={Rup24} alt="Gallery" className="gallery-img" />
            </div>
          </div>

          {/* Register */}
          {/* <div ref={registerRef} className="ai-section">
            <div className="ai-register-section">
              <h3 className="ai-countdown">
                Registration Starts in:{" "}
                <span>
                  {timeLeft.days}d {timeLeft.hours}h {timeLeft.minutes}m{" "}
                  {timeLeft.seconds}s
                </span>
              </h3>
            </div>
          </div> */}
        </div>
      </div>

      {/* Scroll-to-top */}
      {isVisible && (
        <button className="scroll-to-top" onClick={scrollToTop}>
          <FaArrowUp />
        </button>
      )}

      <footer className="ai-footer">
        <p>
          © 2025 Digital Pakistan AI Wrapper Competition. All rights reserved.
        </p>
      </footer>
    </>
  );
};

export default AIWrapper;
